export function euros(cents: number): string {
  // Muestra los decimales cuando los hay (34,90 €) y deja limpios los importes
  // redondos (30 €), en vez de redondear todo a euros enteros.
  const hasCents = cents % 100 !== 0;
  return (cents / 100).toLocaleString('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: 2,
  });
}

/** Solo el número del importe en euros, sin el símbolo €, con decimales cuando
 *  los hay: "34,90" / "35". Para usos donde el "€" lo añade otro texto
 *  (p.ej. "{n}€ / persona" o el precio dentro del plano de mesas). */
export function eurosAmount(cents: number): string {
  const hasCents = cents % 100 !== 0;
  return (cents / 100).toLocaleString('es-ES', {
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: 2,
  });
}

export function formatDate(iso: string, locale = 'es-ES'): string {
  return new Date(iso).toLocaleDateString(locale, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  });
}

/** Long date with only the first letter capitalised: "Viernes, 1 de mayo". */
export function formatDateLong(iso: string, locale = 'es-ES'): string {
  const s = formatDate(iso, locale);
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function formatTime(iso: string): string {
  // Brand convention (see DORIS.pdf): times use a period separator — "19.00".
  return new Date(iso)
    .toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
    })
    .replace(':', '.');
}
